<template>

  <t-dialog-form :generalErrors="generalErrors" :title="title" :ok-text="okText" @show="showModal" @hidden="resetModal"
                 :id="id" :command="command" :status="status" :variant="variant"
                 large
                 tabs
                 :disabled-submit="disablePrint || (!businessRule.enable && hasBusinessRule)"
                 ref="dialog_form" @onSubmit="onSubmit">

    <t-form-tab title="Impressão" class="border">

        <b-card-title v-if="headerTitle.length > 0">{{ headerTitle }}</b-card-title>

        <t-input v-model="form.labelId" v-if="labelOptions.length > 0" radio required :options="labelOptions" label="Impressora"/>

        <t-input v-model="form.printerId" select required :options="printerOptions" label="Impressora"/>

        <t-input v-model="form.quantity"
                 :options="quantityOptions"
                 radio v-if="!disableQuantity" only-numbers number required label="Qtd. Cópias"/>


      <div v-if="hasBusinessRule">

        <!-- VALIDAÇÃO DA IMPRESSÃO -->

        <t-msg
            :info="businessRule.enable"
            :danger="!businessRule.enable">

          <strong v-if="businessRule.enable">
            Impressão liberada
          </strong>

          <strong v-else>
            Impressão não liberada
          </strong>

          <div class="mt-1">

      <span v-if="businessRule.printHistoryCount > 1">
        Esta será a <strong>{{ businessRule.printHistoryCount }}ª via</strong> desta etiqueta.
      </span>

            <span v-else>
        Esta será a <strong>1ª via</strong> desta etiqueta.
      </span>

            <span v-if="businessRule.message">
        <br>
        {{ businessRule.message }}
      </span>

          </div>

        </t-msg>


        <!-- ORIENTAÇÃO DA COR DA ETIQUETA -->

        <t-msg
            v-if="businessRule.enable && businessRule.variantInfo"
            class="mt-2"
            :info="businessRule.variant === 'default'"
            :warning="businessRule.variant === 'warning'"
            :danger="businessRule.variant === 'danger'">

          <strong>Cor da etiqueta</strong>

          <div class="mt-1">
            {{ businessRule.variantInfo }}
          </div>

        </t-msg>

      </div>

        <slot>


        </slot>


    </t-form-tab>

    <t-form-tab title="Histórico de Impressões" lazy v-if="enableProductionHistory">


      <ProductionOrderLabelPrintHistory :label-id="labelId" :production-order-id="foreignKey" />


    </t-form-tab>



  </t-dialog-form>

</template>
<script>
import tDialogForm from "@/components/template/dialog/t-dialog-form";
import pageDialogFormMixin from "@/mixins/page/pageDialogFormMixin";
import LabelService from "@/services/modules/general/Label.service";
import ProductionOrderLabelPrintHistory from "@/views/modules/general/ProductionOrderLabelPrintHistory.vue";

export default {
  name: "PrintLabelDialog",
  components: {ProductionOrderLabelPrintHistory, tDialogForm},
  mixins: [pageDialogFormMixin],
  data() {
    return {
      id: "modal-print-label",
      title: "",
      okText: "Imprimir",
      form: {
        labelId: 0,
        printerId: 0,
        quantity: 1,
        list: "",//Será feita conversão para envio json encoded
      },
      error: {//Campos que podem receber retorno de erro do backend
        name: "",
      },
      variant: "primary",
      label: {},
      printerDefault: {},
      printerOptions: [],
      quantityOptions: [{value: 1, text: '1'}, {value: 2, text: '2'}, {value: 3, text: '3'}, {value: 4, text: '4'}, {value: 5, text: '5'}],
      hasBusinessRule:false,
      businessRule: {
        enable: true,
        variant: "default",
        variantInfo: "",
        quantityRestrict: 0,
        printHistoryCount: 1,
        message: ""
      },

    }
  },
  props: {
    headerTitle: { //Titulo da
      type: String,
      default: "",
    },
    enableProductionHistory: Boolean,
    disableQuantity: Boolean,
    disablePrint: Boolean,
    labelOptions: {
      type: Array,
      default: () => [],
    },
    labelId: {
      type: Number,
      required: true,
    },
    list: [],//Recebe sempre um array
    foreignKeyColumn: {/*Declarado sempre pontualmente em cada Dialog, pois poderá ser fixo ou vindo de props*/
      type: String,
      default: "",
      required: false,
    },
  },
  mounted() {
    this.id += '-' + this.labelId
  },

  methods: {

    //Declaro sempre localmente, pois poderá realizar operações diferentes do padrão como setar algum valor padrão vindo de fora e que seria limpo pelo resetModal de forma dinamica
    async showModal() {

      //Limpa os campos
      this.resetModal()

      this.form.labelId = this.labelId


      //Setar alguma informações padrão por exemplo vindo de fora
      await LabelService.mount(this.labelId,this.foreignKey).then((response) => {

        this.label = response.label
        this.printerDefault = response.printerDefault
        this.printerOptions = response.printerOptions
        this.form.quantity = 1

        if (response.businessRule) {

          this.hasBusinessRule = true

          this.businessRule = {
            ...this.businessRule,
            ...response.businessRule
          }

          if (this.businessRule.quantityRestrict > 0) {

            this.form.quantity = this.businessRule.quantityRestrict

            this.quantityOptions = this.quantityOptions.filter(
                item => item.value <= this.businessRule.quantityRestrict
            )

          }





        }

        if (this.printerDefault !== null) {
          this.form.printerId = this.printerDefault.printerId
        }


        this.title = 'Imprimir: ' + this.label.name

      }).catch(error => alert(error))

    },

    async onSubmit() {

      if (this.foreignKeyColumn === '' || this.foreignKey === 0)
        alert('Montagem de Impressão incorreta!')

      this.form[this.foreignKeyColumn] = this.foreignKey

      if (this.list) {

        if (this.list.length > 0) {
          //Converte objeto para envio como uma string, pois poderá existir diversas formas de envio de listas de etiquetas
          this.form.list = JSON.stringify(this.list)
        }

      } else {
        this.form.list = ""
      }

      this.status = "sending"

      await LabelService.print(this.form).then(() => {

        this.itemInserted.value = this.primaryKey
        this.itemInserted.text = this.label.name

        this.successInsert()

      })

    }
  }
}
</script>
